import moment from "moment";
import { useRiskWire } from "../__consumer/useRiskWire/useRiskWire.data";
import { GenericIndexComparison } from "./types.old";
import { Moment } from "moment-timezone";

export const riskPerformanceFormatterV1 = (
  volatilityResponseData: ReturnType<
    typeof useRiskWire
  >["serverData"]["volatilityResponse"]["data"],
  frequency: "Daily" | "Monthly" = "Daily",
  annualizationDate?: Moment
) => {
  const statistics = volatilityResponseData?.data?.portfolio?.statistics;
  const benchStats = volatilityResponseData?.data.benchmark?.statistics;
  const staticPerformanceData: GenericIndexComparison[] = [
    {
      name: annualizationDate
        ? `${"Portfolio Stats (up to "}${moment(annualizationDate).format(
            "DD MMM` YY"
          )})`
        : "",
      key: "header",
      value: {
        value: undefined,
        type: "NotANumber",
        suffix: "Portfolio",
      },
      indexValue: {
        value: undefined,
        type: "NotANumber",
        suffix: volatilityResponseData?.data?.benchmark?.indexName,
      },
    },
    {
      name: `Performance to ${"date"}`,
      key: "performanceToDate",
      value: {
        value: statistics?.periodPerformance,
        type: "RedWhenNegative",
        suffix: "%",
      },
      indexValue: {
        value: benchStats?.periodPerformance,
        type: "RedWhenNegative",
        suffix: "%",
      },
    },
    {
      name: `Average Annual Return`,
      key: "avgAnnualReturn",
      value: {
        value: volatilityResponseData?.data?.portfolio?.annualReturn,
        type: "RedWhenNegative",
        suffix: "%",
      },
      indexValue: {
        value: volatilityResponseData?.data?.benchmark?.annualReturn,
        type: "RedWhenNegative",
        suffix: "%",
      },
    },
    {
      name: `Return: Best ${frequency === "Daily" ? "Day" : "Month"}`,
      key: "returnBestDay",
      value: {
        value: Number(statistics?.bestReturn ?? -1),
        displayValue:
          Number(statistics?.bestReturn ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "GreenWhenPositive",
        suffix: "%",
      },
      indexValue: {
        value: Number(benchStats?.bestReturn ?? -1),
        displayValue:
          Number(benchStats?.bestReturn ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "GreenWhenPositive",
        suffix: "%",
      },
    },
    {
      name: `Return: Worst ${frequency === "Daily" ? "Day" : "Month"}`,
      key: "returnWorstDay",
      value: {
        value: Number(statistics?.worstReturn ?? -1),
        displayValue:
          Number(statistics?.worstReturn ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "RedWhenNegative",
        suffix: "%",
      },
      indexValue: {
        value: Number(benchStats?.worstReturn ?? -1),
        displayValue:
          (benchStats?.worstReturn ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "RedWhenNegative",
        suffix: "%",
      },
    },
    {
      name: `% Up ${frequency === "Daily" ? "Days" : "Months"}`,
      key: "percentUpDays",
      value: {
        value: Number(statistics?.percentageUp ?? -1),
        displayValue:
          (Number(statistics?.percentageUp) ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "RedWhenNegative",
        suffix: "%",
      },
      indexValue: {
        value: Number(benchStats?.percentageUp ?? -1),
        displayValue:
          Number(benchStats?.percentageUp ?? -1).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "RedWhenNegative",
        suffix: "%",
      },
    },
    {
      name: `Longest Drawdown Period (${
        frequency === "Daily" ? "Days" : "Months"
      })`,
      key: "longestDrawdownPeriodDays",
      value: {
        value: statistics?.longestDrawdownPeriod ?? -1,
        type: "NeutralNumber",
        suffix: "",
      },
      indexValue: {
        value: benchStats?.longestDrawdownPeriod ?? -1,
        type: "NeutralNumber",
        suffix: "",
      },
    },
    {
      name: `Biggest Drawdown`,
      key: "biggestDrawdown",
      value: {
        value: statistics?.biggestDrawdown ?? -1,
        type: "GreenWhenPositive",
        suffix: "%",
      },
      indexValue: {
        value: benchStats?.biggestDrawdown ?? -1,
        type: "GreenWhenPositive",
        suffix: "%",
      },
    },
  ];

  return staticPerformanceData;
};
